import React, { useEffect, useState } from "react";
import "./Navbar.css";

/**
 * Premium Mobile Service Navbar (fixed, large mobile logo & icon)
 */
export default function Navbar({
  logoSrc = "/logoservice.png",
  brandAlt = "Dempsey Mobile Service",
  onNavigate = (path) => (window.location.href = path),
  active = "/",
  enableTopbar = false,
}) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
  
  ];

  const handleNavClick = (path) => {
    onNavigate(path);
  };

  return (
    <>
      <header
        className={`kf-header kf-header--fixed ${scrolled ? "scrolled" : ""}`}
        style={{ "--kf-top-h": enableTopbar ? "44px" : "0px" }}
      >
        {/* Mainbar */}
        <div className="kf-mainbar" role="navigation" aria-label="Primary">
          <div className="kf-container">
            <div className="kf-mainbar__content">
              <div className="kf-brand">
                <div className="kf-brand__logo">
                  <img src={logoSrc} alt={brandAlt} />
                </div>
              </div>

              {/* Desktop Navigation */}
              <nav className="kf-nav" aria-label="Main navigation">
                <ul className="kf-nav__list">
                  {navItems.map((item) => (
                    <li key={item.path} className="kf-nav__item">
                      <button
                        className={`kf-nav__link ${
                          active === item.path ? "active" : ""
                        }`}
                        onClick={() => handleNavClick(item.path)}
                        aria-current={active === item.path ? "page" : undefined}
                      >
                        {item.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>

              <div className="kf-actions">
                <a
                  href="tel:+1 253-319-2612"
                  className="kf-phone"
                  aria-label="Call now 253-319-2612"
                >
                  <span className="kf-phone__icon" aria-hidden>
                    <svg
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="currentColor"
                    >
                      <path d="M6.6 10.8a15.5 15.5 0 0 0 6.6 6.6l2.2-2.2a1.5 1.5 0 0 1 1.5-.37 11.6 11.6 0 0 0 3.6.58 1.5 1.5 0 0 1 1.5 1.5V20A2 2 0 0 1 20 22 18 18 0 0 1 2 4a2 2 0 0 1 2-2h2.1A1.5 1.5 0 0 1 7.6 3.5c0 1.22.2 2.42.58 3.6.2.5.1 1.07-.3 1.46L6.6 8.8z" />
                    </svg>
                  </span>
                  <div className="kf-phone__info">
                    <span className="kf-phone__label">Call Now</span>
                    <span className="kf-phone__number">253-319-2612</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Spacer that always equals header height */}
      <div className="kf-header-spacer" aria-hidden />
    </>
  );
}
